import {OAUTH} from '../actionTypes'
import {asyncNames} from '../../lib/asyncUtil'
import {stateValue} from '../../lib/data'

const initialState = {loading: false, scopes: [], permissions: [], failed: false, error: null, message: null}

// Only the listing includes every permission. A created scope includes just its own, and a sign-in
// scope none at all, so treating that as the whole list would empty every other scope's card.
const permissionsValue = ({data, included, records = []}) => {
  if (Array.isArray(data))
    return included

  const includedIds = included.map(permission => permission.id)

  return [...records.filter(permission => !includedIds.includes(permission.id)), ...included]
}

const oauthReducer = (state = initialState, action) => {
  switch(action.type) {
    case asyncNames(OAUTH).loading:
      return {...state, loading: action.data, error: null, failed: false}
    case asyncNames(OAUTH).failure:
      return {...state, loading: false, error: action.data.error, failed: action.data.status}
    case asyncNames(OAUTH).success:
      return {
        ...state,
        loading: false,
        scopes: stateValue({data: action.data, records: state.scopes}),
        permissions: permissionsValue({data: action.data, included: action.included, records: state.permissions})
      }
    default:
      return state
  }
}

export default oauthReducer
